import React, { FC } from 'react';
import { classes, st } from './Player.st.css';
import { PlaybackComponentProps } from './Player.types';
import {
  GqlVideoFragment,
  GqlVideoSource,
} from '../../../apollo/generated/graphql';
import { Playable } from './players/Playable';
import { usePlayback } from '../../../hooks';
import { ReactPlayer } from './players/ReactPlayer';

const PlaybackComponents: {
  [key in GqlVideoSource]: FC<PlaybackComponentProps>;
} = {
  [GqlVideoSource.Computer]: Playable,
  [GqlVideoSource.Dropbox]: Playable,
  [GqlVideoSource.GoogleDrive]: Playable,
  [GqlVideoSource.Live]: Playable,
  [GqlVideoSource.Facebook]: ReactPlayer,
  [GqlVideoSource.Vimeo]: ReactPlayer,
  [GqlVideoSource.Youtube]: ReactPlayer,
};

type Props = {
  video: GqlVideoFragment;
};

export const Player: FC<Props> = ({ video }) => {
  const {
    source,
    title,
    play: {
      entity: { url },
    },
  } = video;
  const { playing, pause } = usePlayback();
  const PlaybackComponent = PlaybackComponents[source];

  return (
    <div
      className={st(classes.root, {
        visible: playing,
      })}
    >
      {url && (
        <PlaybackComponent
          key={url}
          src={url}
          title={title}
          playing={playing}
          onEnded={pause}
        />
      )}
    </div>
  );
};
